import React, { useState } from "react";
import Select from "react-select";
export default function Index() {
  // const [selectedOption, setSelectedOption] = useState(null);
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const handleChange = () => { };

  return (
    <div>
      9:4
      <Select value={options[0]} onChange={handleChange} options={options} />
    </div>
  );
}
